import { SafeString } from 'handlebars/dist/handlebars';

/**
 * Alternative replacement for `<p>` blocks.
 */
export function p(...args) {
  const options = args.pop();
  const attrs = [ 'id', 'class' ]
    .map(a => options.hash[a] ? ` ${a}="${options.hash[a]}"` : '')
    .join('');
  return new SafeString(`<p${attrs}>${options.fn(this)}</p>`);
}
